export default {
  title: 'System Upgrade Notification',
  button: 'Refresh',
  content: `A newer version of the system has been detected.
  Please refresh the page to continue.`,
};
